import { render } from "./OcrReportTableNav.vue?vue&type=template&id=635f928a"
import script from "./OcrReportTableNav.vue?vue&type=script&lang=js"
export * from "./OcrReportTableNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__